// components/module/compras/components/PriceUpdateDialog.tsx
import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  Box,
} from '@mui/material';
import { ArticuloCompra } from '../../../types/purchaseOrder.types';

interface PriceUpdateDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  priceUpdates: Array<{
    Id: number;
    PrecioCompra: number;
  }>;
  articulos: ArticuloCompra[];
  isSaving: boolean;
}

const PriceUpdateDialog: React.FC<PriceUpdateDialogProps> = ({
  open,
  onClose,
  onConfirm,
  priceUpdates,
  articulos,
  isSaving,
}) => (
  <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle>Confirmar Actualización de Precios</DialogTitle>
    <DialogContent>
      <Typography>
        Algunos artículos tienen precios diferentes a los registrados en el sistema.
        ¿Desea actualizar los precios al guardar la orden?
      </Typography>
      <Box className="mt-4">
        <Typography variant="subtitle2" className="mb-2">Artículos a actualizar:</Typography>
        {priceUpdates.map((update, index) => {
          const articulo = articulos.find(a => a.IdArticulo === update.Id);
          return (
            <Box key={index} className="mt-2 p-2 bg-gray-50 rounded">
              <Typography className="text-sm">
                <span className="font-medium">{articulo?.articulo?.Nombre}</span>
                <br/>
                <span className="text-gray-600">
                  Precio actual: ${articulo?.articulo?.PrecioCompra} 
                  {' → '} 
                  Nuevo precio: ${update.PrecioCompra}
                </span>
              </Typography>
            </Box>
          );
        })}
      </Box>
    </DialogContent>
    <DialogActions>
      <Button 
        onClick={onClose}
        variant="outlined"
        disabled={isSaving}
      >
        Cancelar
      </Button>
      <Button 
        onClick={onConfirm} 
        variant="contained" 
        color="primary"
        disabled={isSaving}
      >
        {isSaving ? 'Guardando...' : 'Confirmar y Guardar'}
      </Button>
    </DialogActions>
  </Dialog>
);

export default PriceUpdateDialog;